import ConfigParameter, { gettext } from "../ConfigParameter";

export default class LabelsPosition extends ConfigParameter {

    constructor() {
        super('labelsPosition', 'selectionButtons', gettext('Labels position'), 'position', 'top', null, [
            {value: 'top', template: '<em class="material-icons icon-size form-label-position">arrow_upward</em>'},
            {value: 'left', template: '<em class="material-icons icon-size form-label-position">arrow_back</em>'}
        ]);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/LabelsPosition.js